// extracted by mini-css-extract-plugin
module.exports = {"box":"user-story-description_box__2NZGe","header":"user-story-description_header__13wpl","time":"user-story-description_time__3XWU7","text":"user-story-description_text__3cLwh"};